var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "100%",
      width: "100%"
    }
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#BF0637"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 29.167c-11.48 0-20.834 9.354-20.834 20.833 0 11.48 9.354 20.833 20.833 20.833 11.48 0 20.834-9.354 20.834-20.833 0-11.48-9.355-20.833-20.834-20.833Zm7 25.625A1.572 1.572 0 0 1 57 57a1.545 1.545 0 0 1-1.105.458c-.396 0-.792-.145-1.104-.458l-4.792-4.792L45.208 57a1.545 1.545 0 0 1-1.105.458c-.395 0-.791-.145-1.104-.458a1.572 1.572 0 0 1 0-2.208L47.791 50l-4.792-4.792A1.572 1.572 0 0 1 43 43a1.572 1.572 0 0 1 2.209 0l4.791 4.792L54.791 43a1.572 1.572 0 0 1 2.208 0 1.572 1.572 0 0 1 0 2.208L52.208 50l4.791 4.792Z",
    fill: "#fff"
  })));
};
export default SvgError;